import setSiteMeta from '../base-saving-actions/set-site-meta';

export default function updateCurrentColorPaletteVersion(initialVersion, newVersion) {
  return initialVersion !== newVersion
    ? [setSiteMeta(['customization', 'currentColorPaletteVersion'], newVersion)]
    : [];
}
